
// radio 单选框 , input 输入框 , select 下拉框
// disabled 1可用  0 禁用
// required 1 必填 0 不必填
// message 文字信息
// sub 参数设置

export const list = [
    {label:'资格证申请',type:'radio',disabled:'1',sub:'firstApply',required:'1',message:'请选择'},
    {label:'申请属性',type:'radio',disabled:'1',sub:'applyAttruble',required:'1',message:'请选择'},
    {label:'已入住房源',type:'input',disabled:'1',sub:'residenceInfo',required:'1',message:'请填写完整'},
    {label:'申请类型',type:'radio',disabled:'1',sub:'applyType',required:'1',message:'请选择'},
    // {label:'意向项目',type:'select',disabled:'1',sub:'intentionProject',required:'1',message:'请选择'},
    // {label:'户型意向',type:'select',disabled:'1',sub:'applyHouseType',required:'1',message:'请选择'},
]

//数据格式主申请人
export const transactionAdditionList = [
    {transactionAdditionType: "主申请人附件", kind: "身份证",content:''},
    {transactionAdditionType: "主申请人附件", kind: "户籍证明",content:''},
    {transactionAdditionType: "主申请人附件", kind: "劳动合同",content:''},
    {transactionAdditionType: "主申请人附件", kind: "营业执照",content:''},
    {transactionAdditionType: "主申请人附件", kind: "买卖合同",content:''},
    {transactionAdditionType: "主申请人附件", kind: "动迁协议",content:''},
    {transactionAdditionType: "主申请人附件", kind: "预售合同",content:''},
    {transactionAdditionType: "主申请人附件", kind: "结婚证",content:''},
    {transactionAdditionType: "主申请人附件", kind: "离婚证明",content:''},
    {transactionAdditionType: "主申请人附件", kind: "单身承诺",content:''},
    {transactionAdditionType: "主申请人附件", kind: "丧偶证明",content:''},
    {transactionAdditionType: "主申请人附件", kind: "居住证",content:''},
    {transactionAdditionType: "主申请人附件", kind: "其他",content:''},
    {transactionAdditionType: "主申请人附件", kind: "社保缴纳证明",content:''},
    {transactionAdditionType: "主申请人附件", kind: "准入资格重审单",content:''},
    {transactionAdditionType: "主申请人附件", kind: "证明模板",content:''},
    {transactionAdditionType: "主申请人附件", kind: "住房申请提交证明",content:''},
    {transactionAdditionType: "主申请人附件", kind: "准入资格申清表",content:''},
    {transactionAdditionType: "主申请人附件", kind: "过渡居住申请书",content:''},
]
export const kindList = [
    '房屋权利证明','租用居住攻方凭证','回执'
]
export const strHousing = [
    {transactionAdditionType: "住房情况附件",kind: "房屋权利证明", content: ""},
    {transactionAdditionType: "住房情况附件",kind: "回执", content: ""},
]
export const strHousingThree = [
    {transactionAdditionType: "住房情况附件",kind: "租用居住攻方凭证", content: ""},
    {transactionAdditionType: "住房情况附件",kind: "回执", content: ""},
]
//主申请人本市住房情况附件
export const housingAnnex = []
export const housingAnnexTwo = []
export const housingAnnexThree = []

//共同申请人
export const joinhousingAnnex = []
export const joinhousingAnnexTwos = []
export const joinhousingAnnexThree = []

//共同申请人
export const jointApplicants = [
    {transactionAdditionType: "共同申请人附件", kind: "身份证",content:''},
    {transactionAdditionType: "共同申请人附件", kind: "出生证明",content:''},
    {transactionAdditionType: "共同申请人附件", kind: "户籍证明",content:''},
    {transactionAdditionType: "共同申请人附件", kind: "买卖合同",content:''},
    {transactionAdditionType: "共同申请人附件", kind: "动迁协议",content:''},
    {transactionAdditionType: "共同申请人附件", kind: "预售合同",content:''},
    {transactionAdditionType: "共同申请人附件", kind: "结婚证",content:''},
    {transactionAdditionType: "共同申请人附件", kind: "离婚证明",content:''},
    {transactionAdditionType: "共同申请人附件", kind: "单身承诺",content:''},
    {transactionAdditionType: "共同申请人附件", kind: "其他",content:''},
]
//共同申请人暂存
export const jointAppLists = []
